<template>
  <div class="vx-row">
    <!-- HORIZONTAL LAYOUT -->
    <div class="vx-col w-full mb-base">
      <form @submit.prevent="onSubmit">
        <vx-card name="Create Product">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Name</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span class="text-normal text-sm">{{ countChar(name) }}/250</span>
              <vs-input
                v-validate="'required|max:250'"
                class="w-full"
                v-model="name"
                name="Name"
              />
              <span class="text-danger text-sm" v-show="errors.has('Name')">{{
                errors.first("Name")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>
                Description
                <small>*Max. 1000 Character</small>
              </span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span class="text-normal text-sm"
                >{{ countChar(description) }}/1000</span
              >
              <vs-textarea
                v-validate="'required|max:1000'"
                class="w-full"
                v-model="description"
                name="Description"
                type="number"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Description')"
                >{{ errors.first("Description") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Price</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span class="text-normal text-sm">Rp. </span>
              <vs-input
                v-validate="'required|max:250'"
                class="w-full"
                v-model="price"
                name="Price"
                type="number"
              />
              <span class="text-danger text-sm" v-show="errors.has('Price')">{{
                errors.first("Price")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Stock</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span class="text-normal text-sm">Unit</span>
              <vs-input
                v-validate="'required|max:250'"
                class="w-full"
                v-model="stock"
                name="Stock"
                type="number"
              />
              <span class="text-danger text-sm" v-show="errors.has('Stock')">{{
                errors.first("Stock")
              }}</span>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Weight</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span class="text-normal text-sm">Gram</span>
              <vs-input
                v-validate="'required|max:250'"
                class="w-full"
                v-model="weight"
                name="Weight"
                type="number"
              />
              <span class="text-danger text-sm" v-show="errors.has('Weight')">{{
                errors.first("Weight")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Sizes</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span class="text-normal text-sm">Ex : SM,M,L</span>
              <vs-input
                v-validate="'required'"
                class="w-full"
                v-model="sizes"
                name="Size"
              />
              <span class="text-danger text-sm" v-show="errors.has('Size')">{{
                errors.first("Size")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Colors</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span class="text-normal text-sm">Ex : Merah,Hijau,Kuning</span>
              <vs-input
                v-validate="'required'"
                class="w-full"
                v-model="colors"
                name="Color"
              />
              <span class="text-danger text-sm" v-show="errors.has('Color')">{{
                errors.first("Color")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Status</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span class="text-normal text-sm">Status</span>
              <v-select
                v-model="status"
                v-validate="'required'"
                label="name"
                item-value="id"
                :options="listStatus"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                name="Status"
              />
              <span class="text-danger text-sm" v-show="errors.has('Status')">{{
                errors.first("Status")
              }}</span>
            </div>
          </div>

          <div class="vx-row mb-6" v-if="status.value == 1">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Preorder Duration</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span class="text-normal text-sm">Day</span>
              <vs-input
                v-validate="'required|max:250'"
                class="w-full"
                v-model="preorder_duration"
                name="Preorder"
                type="number"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Preorder')"
                >{{ errors.first("Preorder") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-6" v-if="status.value == 3">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Limit Order</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span class="text-normal text-sm">Unit</span>
              <vs-input
                v-validate="'required|max:250'"
                class="w-full"
                v-model="order_limit_count"
                name="OrderLimit"
                type="number"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('OrderLimit')"
                >{{ errors.first("OrderLimit") }}</span
              >
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Photos</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span class="text-normal text-sm"
                >Photo size 720px x 720px and max file size 1MB</span
              >
              <vs-input
                class="w-full"
                type="file"
                id="photo"
                name="Photos"
                accept="image/x-png, image/jpeg, image/jpg"
                @change="onMultipleFileSelected"
                multiple
              />
              <br />
              <span class="text-danger text-sm" v-show="photo_error"
                >{{ photo_error_message }}
              </span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button class="mr-3 mb-2" button="submit">Submit</vs-button>
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>

<script>
import QuillCustom from '../template/QuillCustom'
import PreviewJob from '../template/PreviewJob'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import axios from '../../../axios'
import router from '../../../router'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
export default {
  data() {
    return {
      userAuth: this.$store.state.user,
      company: JSON.parse(localStorage.getItem('company')),
      bidangPekerjaan: [],
      name: '',
      price: '',
      stock: '',
      weight: '',
      sizes: '',
      colors: '',
      description: '',
      preorder_duration: '',
      order_limit_count: '',
      photo: '',
      photos: [],
      photo_error: 0,
      photo_error_message: '',
      listStatus: [{ value: 0, name: 'Normal' }, { value: 1, name: 'Preorder' }, { value: 3, name: 'Limited' }, { value: 2, name: 'Draft' }],
      status: { value: 0, name: 'Normal' },
      colorAlert: 'primary',
      nameAlert: 'Alert',
      activeAlert: false,
      valueInput: '',


      editorDesc: {
        modules: {
          toolbar: '#desc'
        }
      },
      editorReq: {
        modules: {
          toolbar: '#req'
        }
      },
      editorBenefit: {
        modules: {
          toolbar: '#description'
        }
      },
      content: '',
      colorx: "white",
      popupActive: false,
      lowongan_button_status: true,
      company_button_status: false,
    }
  },
  components: {
    quillEditor,
    'v-select': vSelect,
    Datepicker,
    QuillCustom,
    PreviewJob
  },
  mounted() {

  },

  methods: {

    countChar(str) {
      return str.length
    },
    limitChar(str) {
      var output = ''
      if (str.length > 100) {
        str = str.substring(0, 100)
        output = str + '...'
      } else {
        output = str
      }
      return output
    },
    format_date(value) {
      // if (value) {
      //   return moment(String(value)).format('YYYY-MM-DD')
      // }

      const d = value
      const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d)
      const mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(d)
      const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d)
      return `${da} ${mo} ${ye}`
    },
    onSubmit() {
      var formData = new FormData();

      if (this.photos) {

        for (var i = 0; i < this.photos.length; i++) {
          formData.append('photos[' + i + ']', this.photos[i])

        }

      }
      formData.append('store_id', this.userAuth.company.id)
      formData.append('name', this.name)
      formData.append('price', this.price)
      formData.append('stock', this.stock)
      formData.append('weight', this.weight)
      formData.append('sizes', this.sizes)
      formData.append('colors', this.colors)
      formData.append('status', this.status.value)

      formData.append('description', this.description)
      if (this.status.value == 1) {

        formData.append('preorder_duration', this.preorder_duration)
      }
      if (this.status.value == 3) {
        formData.append('order_limit_count', this.order_limit_count)
      }



      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          axios.post('ecommerce/web/product', formData)
            .then(res => {





              this.acceptAlert('success', 'Berhasil', 'Anda berhasil buat product')
              this.$vs.loading.close()
              router.push('/product')




            })
            .catch(error => {
              console.log(error.response)
              this.$vs.loading.close()
              this.photo_error = 1
              this.photo_error_message = "Photo is required, dimensions must 720px x 720px, max file size 1MB, and only jpg, jpeg and png extension allow"
              this.acceptAlert('warning', 'Mohon maaf', 'Data yg anda masukkan belum lengkap, silahkan lengkapi data terlebih dahulu!')


            })
        } else {
          this.acceptAlert('warning', 'Mohon maaf', 'Data yg anda masukkan belum lengkap, silahkan lengkapi data terlebih dahulu!')

        }
      })


    },
    onMultipleFileSelected(event) {


      for (var i = 0; i < event.target.files.length; i++) {
        this.photos[i] = event.target.files[i];

      }
    },

    acceptAlert(color, name, message) {

      this.$vs.notify({
        color,
        name,
        text: message
      })

    },
  },

}
</script>

